import { createActionCreator } from '@pressreader/appstore';
import { BundleOrderDto } from '@pressreader/commerce-api';
import { ISubscriptionProduct, ITrialEligibility } from '@pressreader/commerce-types';

import { MODULE_NAME } from '../constants';

const prefix = `${MODULE_NAME}/`;

interface LoadSubscriptionDonePayload {
    currentSubscription: ISubscriptionProduct;
    activeBundles: BundleOrderDto[] | null;
}

export const loadSubscriptionDone = createActionCreator<LoadSubscriptionDonePayload>(`${prefix}load_subscription_done`);

export const loadTrialEligibilityAction = createActionCreator(`${prefix}load_trial_eligibility`);
export const loadTrialEligibilityBeganEvent = createActionCreator(`${prefix}load_trial_eligibility_began`);
export const loadTrialEligibilityDoneEvent = createActionCreator<{ trialEligibility: ITrialEligibility }>(`${prefix}load_trial_eligibility_done`);
export const loadTrialEligibilityFailedEvent = createActionCreator(`${prefix}load_trial_eligibility_failed`);
export const loadTrialEligibilityCancelledEvent = createActionCreator(`${prefix}load_trial_eligibility_cancelled`);

// Checkout idempotency key (one per checkout attempt; see withIdempotencyKey).
// An attempt is started lazily by `getOrStartCheckoutAttemptKey` at the point the key is used;
// `setCheckoutIdempotencyKey` is how it records the generated value, keeping the reducer pure.
// `resetCheckoutAttempt` states that the attempt in progress is over — cancelled, refused, or
// invalidated by a change of product — so the next purchase starts a new one.
export const setCheckoutIdempotencyKey = createActionCreator<{ key: string }>(`${prefix}set_checkout_idempotency_key`);
export const resetCheckoutAttempt = createActionCreator(`${prefix}reset_checkout_attempt`);
